/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface TcsRealtimeTrackingProps {
  tabId: string | null;
  tabDate: Date | null;
}

export class TcsRealtimeTrackingRecord extends Record<TcsRealtimeTrackingProps>({
  tabId: null as any,
  tabDate: null as any,
}) {
  public static fromJS(json: {
    tabId: string | null;
    tabDate: string | number | Date | null;
  }): TcsRealtimeTrackingRecord {
    if (json == null) {
      throw new Error('TcsRealtimeTrackingRecord.fromJS: parameter cannot be null');
    }
    return new TcsRealtimeTrackingRecord({
      tabId: json.tabId,
      tabDate: json.tabDate != null ? new Date(json.tabDate) : null,
    });
  }

  public static fromJSUnsafe(json: {
    tabId: string | null;
    tabDate: string | number | Date | null;
  }): [TcsRealtimeTrackingRecord, Error[]] {
    if (json == null) {
      throw new Error('TcsRealtimeTrackingRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new TcsRealtimeTrackingRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      tabId: tryOrDefault(
        () => json.tabId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      tabDate: tryOrDefault(
        () => (json.tabDate != null ? new Date(json.tabDate) : null),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: TcsRealtimeTrackingProps) {
    super(props);
    if (props == null) {
      throw new Error('TcsRealtimeTrackingRecord constructor parameter cannot be null');
    }
  }
}

export abstract class TcsRealtimeTrackingViewModelBase implements TcsRealtimeTrackingProps {
  protected readonly _props: TcsRealtimeTrackingProps;
  private _json?: TcsRealtimeTrackingProps;

  get tabId(): string | null {
    return this._props.tabId;
  }
  get tabDate(): Date | null {
    return this._props.tabDate;
  }

  constructor(props: TcsRealtimeTrackingProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        tabId: this._props.tabId,
        tabDate: this._props.tabDate,
      };
    }
    return this._json;
  }
}
